/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { Theme, css } from '@emotion/react'
import { focusRing } from '@zcode-ui/themes'

export const button = ({ colors, spacing, typography }: Theme) => css`
  font-weight: ${typography.fontWeightMedium};
  font-family: ${typography.bodyFontFamily};
  letter-spacing: -0.2px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;

  border: 0;
  border-radius: 6px;
  cursor: pointer;

  transition: all 100ms ease-in-out;
  transition-property: border, background-color, box-shadow;

  user-select: none;

  label: button;

  :disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:focus {
    ${focusRing({ colors, spacing, typography })}
  }
`

export const secondaryButton = ({ colors }: Theme) => css`
  color: ${colors.text};

  background-color: ${colors.background};

  label: secondarybutton;

  :hover:not(:disabled) {
    background-color: ${colors.backgroundDark};
  }
`

export const spacesButton = ({ colors }: Theme) => css`
  color: ${colors.text};

  background-color: ${colors.backgroundLightest};
  border: 1px solid #bbbec2;

  label: spacesbutton;

  :hover:not(:disabled) {
    background-color: ${colors.backgroundLightest};
    border: 1px solid #1f273c;
  }
`
